import React from "react";
import OfferPage from "../components/OfferPage";

const OfferPoc = () => (
  <OfferPage
    ns="offerPoc"
    page="poc"
    path="/offers/poc"
    order={["whatItIs", "forWho", "steps", "after", "faq"]}
  />
);

export default OfferPoc;
